(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('myPosition', {
        templateUrl: 'views/components/views/myPosition/myPosition.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$timeout', 'myPositionService', 'watcherFactory', function ($timeout, myPositionService, watcherFactory) {

            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            var watcher = watcherFactory.$create(vm);

            vm.model = {
                bgMyPosition: {
                    selected: 'MAP',
                    buttons: [
                        { id: 'MAP', label: 'bg_my_pos_map', color: 'primary', onClick: () => vm.model.bgMyPosition.selected = 'MAP' },
                        { id: 'DETAILS', label: 'bg_my_pos_details', color: 'primary', onClick: () => vm.model.bgMyPosition.selected = 'DETAILS' }
                    ]
                },
                urlStringButtons: [
                    { id: 'open', icon: 'fa fa-solid fa-window-restore', color: 'primary', type: 'primary', onClick: () => window.open(vm.model.position.urlstring) }
                ],
                position: {},
                center: [],
                autoTrack: '0',
                autoCenter: '1',
                fullScreen: false,
                lockedMyPosition: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region GET NAVIGATION POSITION FUNCTION
            
            async function updateMyPosition() {
                navigator.geolocation.getCurrentPosition(function (data) {
                    vm.model.lockedMyPosition = false;

                    vm.model.position.latitude = data.coords.latitude;
                    vm.model.position.longitude = data.coords.longitude;
                    vm.model.position.altitude = data.coords.altitude;
                    vm.model.position.accuracy = data.coords.accuracy;

                    vm.model.position.urlstring = 'https://sar.hovedredningssentralen.no/hrs/kart.html?lat=' + vm.model.position.latitude + '&lng=' + vm.model.position.longitude + '&zl=20&pt=pos';

                    if (vm.model.autoCenter === '1') {
                        vm.model.center.length = 0;
                        vm.model.center.push(vm.model.position.latitude);
                        vm.model.center.push(vm.model.position.longitude);
                    }

                    //if (vm.model.autoTrack === '1') autoTrack();
                });
            }

            vm.getMyPosition = function () {
                vm.model.lockedMyPosition = true;
                updateMyPosition();
            }

            // #endregion GET NAVIGATION POSITION FUNCTION

            // #region AUTO TRACK FUNCTION

            var trackerTimer = null;
            
            var autoTrack = function () {
                if (angular.isDefined(trackerTimer)) {
                    $timeout.cancel(trackerTimer);
                }
                
                updateMyPosition();
                
                trackerTimer = $timeout(function () {
                    autoTrack();
                }, 5000);
            };

            // #endregion AUTO TRACK FUNCTION

            // #region LOAD PROCEDURE CALL
            
            async function loadPosition() {
                vm.model.position = (await myPositionService.getPosition())[0];

                return updateMyPosition();
            }

            // #endregion LOAD PROCEDURE CALL

            // #region BUTTON RADIO FUNCTION

            vm.selectBgMyPosition = function (value) {
                vm.model.bgMyPosition.selected = value;
            }

            // #endregion BUTTON RADIO FUNCTION

            // #region OPEN WEB LINK MAP FUNCTION
            
            vm.openWebLinkMyPos = function () {
                window.open(vm.model.position.urlstring);
            }

            // #endregion OPEN WEB LINK MAP FUNCTION

            // #region WATCH FUNCTION
            
            watcher.$watch(function () {
                return vm.model.autoTrack;
            }, function (newValue, oldValue) {
                if (angular.isUndefined(vm.model.autoTrack) || angular.isUndefined(newValue)) return;
                
                if (vm.model.autoTrack === '1') {
                    autoTrack();
                } else {
                    if (angular.isDefined(trackerTimer) || vm.model.autoTrack !== '1') {
                        $timeout.cancel(trackerTimer);
                    }
                }
            });

            // #endregion WATCH FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadPosition();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
